import { RFP_ACTION } from "./actions";
import initialState from "../../../../reducers/initialState";

const RFPReducer = (state = initialState, action) => {
  switch (action.type) {
    case RFP_ACTION.UPDATE_RFP_STATUS: {
      return {
        ...state,
        rfpStatus: action.rfpStatus,
      };
    }
    //در انتظار ثبت
    case RFP_ACTION.UPDATE_WAITING_RFP_LIST: {
      return {
        ...state,
        waitingRfpList: action.data,
      };
    }
    case RFP_ACTION.UPDATE_RFP_BADGE_COUNT: {
      return {
        ...state,
        waitingRfpBadgeCount: action.badgeCount.penddingRFP,
        inProgressRFPCount: action.badgeCount.inprogressRFP,
      };
    }
    case RFP_ACTION.UPDATE_INPROGRESS_RFP_LIST: {
      return {
        ...state,
        inProgressRfpList: action.data,
      };
    }
    //مشاهده مدارک مهندسی
    case RFP_ACTION.VIEW_DOC_MODAL: {
      return {
        ...state,
        ViewDocsModal: !state.ViewDocsModal,
        viewDocList: action.data,
        CurrentDoc: action.CurrentDoc,
        RevisionsLog: action.RevisionsLog,
      };
    }
    case RFP_ACTION.CLOSE_VIEW_DOC_MODAL: {
      return {
        ...state,
        ViewDocsModal: !state.ViewDocsModal,
        viewDocList: [],
        CurrentDoc: {},
        RevisionsLog: [],
      };
    }
    //افزودن مواد
    case RFP_ACTION.ADD_MATERIALS_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
        ListofMaterials: action.data,
      };
    }
    //action = register
    case RFP_ACTION.CLOSE_ADD_MATERIAL_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
      };
    }
    case RFP_ACTION.CONFIRM_CLOSE_ADD_MATERIAL_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
      };
    }
    //action = details
    case RFP_ACTION.CLOSE_DETAILS_MATERIAL_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
        ListofMaterials: [],
      };
    }
    case RFP_ACTION.CONFIRM_CLOSE_DETAILS__MATERIAL_MODAL: {
      return {
        ...state,
        AddNewMaterialsModal: !state.AddNewMaterialsModal,
      };
    }

    case RFP_ACTION.UPDATE_LIST_OF_MATERIALS: {
      return {
        ...state,
        ListofMaterials: action.data,
      };
    }
    case RFP_ACTION.UPDATE_SELECTED_MATERIALS_LIST: {
      return {
        ...state,
        ListofMaterials: action.ListofMaterials,
        selectedMaterials: action.selectedMaterials,
      };
    }
    // details action
    case RFP_ACTION.UPDATE_SELECTED_MATERIALS_LIST_FOR_DETAILS: {
      return {
        ...state,
        selectedMaterials: action.selectedMaterials,
      };
    }
    //لیست
    case RFP_ACTION.UPDATET_RFP_LIST: {
      return {
        ...state,
        rfpList: action.data,
        defaultRFP: action.defaultRFP,
      };
    }
    case RFP_ACTION.UPDATE_RFP_DETAILS_INFO_BY_DEFAULT: {
      return {
        ...state,
        RFPDetailsInfo: action.data,
      };
    }
    case RFP_ACTION.UPDATE_RFP_DETAILS_INFO: {
      return {
        ...state,
        rfpList: action.newrfpList,
        defaultRFP: action.defaultRFP,
        RFPDetailsInfo: action.RFPDetailsInfo,
      };
    }
    case RFP_ACTION.RESET_CREATE_LIST_OF_RFP_STORE: {
      return {
        ...state,
        selectedMaterials: [],
      };
    }
    case RFP_ACTION.UPDATE_DEFAULT_RFP: {
      return {
        ...state,
        defaultRfp: action.data,
      };
    }
    //---تامین کنندگان---
    case RFP_ACTION.SUPPLIER_MODAL_TOGGLE: {
      return {
        ...state,
        AddNewSupplierModal: true,
        ListofSupplier: action.data,
        ListofSupplier2: action.data,
      };
    }
    //register action
    case RFP_ACTION.CLOSE_ADD_SUPPLIER_MODAL: {
      return {
        ...state,
        AddNewSupplierModal: false,
        
        ListofSupplier: [],
        ListofSupplier2: [],
      };
    }
    case RFP_ACTION.CONFIRM_CLOSE_ADD_NEW_SUPPLIER_MODAL: {
      return {
        ...state,
        AddNewSupplierModal: false,
        isSupplierCmp: true,
      };
    }
    // details action
    case RFP_ACTION.CLOSE_DETAILS_SUPPLIER_MODAL: {
      return {
        ...state,
        AddNewSupplierModal: !state.AddNewSupplierModal,
      };
    }
    case RFP_ACTION.CONFIRM_CLOSE_DETAILS_SUPPLIER_MODAL: {
      return {
        ...state,
        AddNewSupplierModal: !state.AddNewSupplierModal,
      };
    }

    case RFP_ACTION.UPDATE_LIST_OF_SUPPLIER: {
      return {
        ...state,
        ListofSupplier: action.data,
      };
    }
    case RFP_ACTION.UPDATE_SELECTED_SUPPLIER_LIST: {
      return {
        ...state,
        ListofSupplier: action.ListofSupplier,
        selectedSuppliers: action.selectedSuppliers,
      };
    }
    // details action
    case RFP_ACTION.UPDATE_SELECTED_SUPPLIER_LIST_FOR_DETAILS: {
      return {
        ...state,
        selectedSuppliers: action.selectedSuppliers,
      };
    }

    case RFP_ACTION.ON_ADD_SELECT_SUPPLIER_HANDLER: {
      return {
        ...state,
        selectedSuppliers: state.selectedSuppliers.concat([action.data]),
        isConfirmBtn: true,
        //selectedSuppliers: [action.data, ...state.selectedSuppliers]
      };
    }
    case RFP_ACTION.ON_REMOVE_SELECT_SUPPLIER_HANDLER: {
      if (action.selectedSuppliers.length === 0) {
        return {
          ...state,
          isSupplierBtn: true,
          AddNewSupplierModal: false,
          isSupplierCmp: false,
          isConfirmBtn: false,
          selectedSuppliers: [],
        };
      }
      return {
        ...state,
        selectedSuppliers: action.selectedSuppliers,
      };
    }
    case RFP_ACTION.ON_DEACTIVE_SUPPLIER_LIST_CMP_HANDLER: {
      return {
        ...state,
        isSupplierCmp: false,
        isSupplierBtn: true,
      };
    }
    case RFP_ACTION.ON_ACTIVE_SUPPLIER_LIST_CMP_HANDLER: {
      return {
        ...state,
        isSupplierCmp: true,
        isSupplierBtn: false,
      };
    }
    case RFP_ACTION.ON_ALL_REMOVE_SUPPLIER_HANDLER: {
      return {
        ...state,
        isSupplierBtn: true,
        AddNewSupplierModal: false,
        isSupplierCmp: false,
        isConfirmBtn: false,
        suppliers: [],
        selectedSuppliers: [],
      };
    }
    //----متن درخواست ---
    case RFP_ACTION.ACTIVE_REQUEST_TEXT: {
      return {
        ...state,
        isActiveRequesText: !state.isActiveRequesText,
      };
    }

    //---- استعلام فنی ---
    case RFP_ACTION.TECHNICAL_INQUIRY_HANDLER: {
      return {
        ...state,
        technicalInquiry: !state.technicalInquiry,
      };
    }
    case RFP_ACTION.UPDATE_TECHNICAL_INQUIRY_LIST: {
      return {
        ...state,
        technicalInquiryList: action.data,
      };
    }
    //---- استعلام بازرگانی ---
    case RFP_ACTION.BUSINESS_INQUIRY_HANDLER: {
      return {
        ...state,
        businessInquiry: !state.businessInquiry,
      };
    }
    case RFP_ACTION.UPDATE_BUSINESS_INQUIRY_LIST: {
      return {
        ...state,
        businessInquiryList: action.data,
      };
    }

    case RFP_ACTION.INITIAL_STATE_RFP_STORE: {
      return {
        ...state,
        rfpStatus: 0,
        selectedSuppliers: [],
        technicalInquiryList: [],
        businessInquiryList: [],
        isSupplierCmp: false,
        isActiveRequesText: false,
        technicalInquiry: false,
        businessInquiry: false,
        ConfirmRejectModal: false,
      };
    }
    case RFP_ACTION.ADVANCED_SEARCH_FILTER: {
      return {
        ...state,
        advancedSearchFilter: !state.advancedSearchFilter,
      };
    }

    case RFP_ACTION.OPEN_CONFIRM_MODAL: {
      return {
        ...state,
        ConfirmRejectModal: !state.ConfirmRejectModal,
        parentFormValues: action.parentFormValues,
        rfpInfo: action.rfpInfo,
      };
    }
    case RFP_ACTION.CLOSE_CONFIRM_MODAL: {
      return {
        ...state,
        ConfirmRejectModal: !state.ConfirmRejectModal,
        parentFormValues: null,
        rfpInfo: {},
      };
    }

    //------Proposal Modal for details----
    case RFP_ACTION.PROPSAL_MODAL: {
      return {
        ...state,
        proposalModal: true,
        proposaltype: action.proposaltype,
        selectedSupplier: action.supplier,
        proposalArray: action.proposalArray,
        evaluationNote: action.evaluationNote,
        evaluationScore: action.evaluationScore,
        inqueryType:action.inqueryType
      };
    }
    case RFP_ACTION.CLOSE_PROPSAL_MODAL: {
      return {
        ...state,
        proposalModal: false,
        proposaltype: "",
        evaluationNote: "",
        proposalComments: [],
        proposalArray: [],
      };
    }
    case RFP_ACTION.UPDATE_PROPOSAL_ARRAY: {
      return {
        ...state,
        proposalArray: action.proposalArray,
      };
    }
    case RFP_ACTION.UPDATE_EVALUATION_SCORE: {
      return {
        ...state,
        evaluationScore: action.evaluationScore,
      };
    }
    case RFP_ACTION.UPDATE_EVALUATION_NOTE: {
      return {
        ...state,
        evaluationNote: action.evaluationNote,
      };
    }
    //---------Inquiry modal for details ------
    case RFP_ACTION.INQUIRY_MODAL_TOGGLE: {
      return {
        ...state,
        InquiryModal: !state.InquiryModal,
        Inquirytype: action.inquiryType,
        inquiryList: action.data,
      };
    }
    case RFP_ACTION.CLOSE_INQUIRY_MODAL_TOGGLE: {
      return {
        ...state,
        InquiryModal: !state.InquiryModal,
        Inquirytype: "",
        inquiryList: [],
      };
    }
    case RFP_ACTION.CONFIRM_INQUIRY_MODAL_TOGGLE: {
      return {
        ...state,
        InquiryModal: !state.InquiryModal,
        Inquirytype: "",
        inquiryList: [],
      };
    }
    case RFP_ACTION.UPDATE_INQUIRY_LIST: {
      return {
        ...state,
        inquiryList: action.data,
      };
    }
    //------ comment ----
    case RFP_ACTION.UPDATE_PROPSAL_COMMENTS_REPLY: {
      return {
        ...state,
        proposalComments: action.comments,
      };
    }

    //-----------winner ------------
    case RFP_ACTION.WINNER_MODAL_TOGGLE: {
      return {
        ...state,
        WinnerModal: !state.WinnerModal,
      };
    }
    case RFP_ACTION.CONFIRM_WINNER_MODAL: {
      return {
        ...state,
        WinnerModal: !state.WinnerModal,
      };
    }
    case RFP_ACTION.UPDATE_RFP_EVALUATION: {
      return {
        ...state,
        rfpEvaluations: action.data,
      };
    }
    default:
      return state;
  }
};

export default RFPReducer;
